<template>
  <div v-if="showComponent">
    <div class="vx-row mt-4">
      <!-- Motivo do Evento -->
      <div class="vx-col lg:w-1/2 xl:w-1/3 w-full mb-2">
        <label for="" class="vs-select--label">Motivo do Evento</label>
        <v-select
          :options="listMotivos"
          name="Tipo Evento"
          id="Tipo Evento"
          v-model="formDadosGerais.idTipoEvento"
          label="label"
          :reduce="(item) => item.id"
          @option:selected="selectMotivoEvento($event)"
        ></v-select>
      </div>

      <!-- Envolvimento -->
      <div class="vx-col lg:w-1/2 xl:w-1/3 w-full mb-2">
        <label for="" class="vs-select--label">Envolvimento</label>
        <v-select
          :options="listEnvolvimentos"
          name="Envolvimento"
          id="Envolvimento"
          v-model="formDadosGerais.idEnvolvimento"
          label="label"
          :reduce="(item) => item.id"
          @option:selected="selectEnvolvimento($event)"
        ></v-select>
      </div>

      <!-- Data e Hora Evento -->
      <div class="vx-col xl:w-1/3 w-full lg:flex lg:gap-5 mb-2">
        <!-- Data do Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Evento</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDay"
              v-model="formDadosGerais.dataEvento"
              placeholder="DD/MM/AAAA"
              name="Data do Evento"
              @input="validaAlteracaoDataEvento(formDadosGerais.dataEvento)"
            />
          </div>
        </div>

        <!-- Hora do Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Hora Evento</label>
          <div class="inputData">
            <vs-input
              class="w-full"
              v-model="formDadosGerais.horaEvento"
              v-mask="'##:##'"
              maxlength="5"
              placeholder="HH:MM"
              name="Hora do Evento"
              @input="
                validaHoraMinuto(formDadosGerais.horaEvento, 'horaEvento')
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Data e Hora Comunicação Evento -->
      <div class="vx-col xl:w-1/4 w-full lg:flex lg:gap-5 mb-2">
        <!-- Data Comunic. Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Comunicação</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDay"
              v-model="formDadosGerais.dataComunicacaoEvento"
              placeholder="DD/MM/AAAA"
              name="Data de Comunicação do Evento"
            />
          </div>
        </div>

        <!-- Hora Comunic. Evento -->
        <div class="xl:w-1/2 w-full">
          <div class="inputData">
            <label class="vs-input--label">Hora Comunicação</label>
            <vs-input
              class="w-full"
              v-model="formDadosGerais.horaComunicacaoEvento"
              v-mask="'##:##'"
              maxlength="5"
              placeholder="HH:MM"
              name="Hora de Comunicação do Evento"
              @input="
                validaHoraMinuto(
                  formDadosGerais.horaComunicacaoEvento,
                  'horaComunicacaoEvento',
                )
              "
            />
          </div>
        </div>
      </div>

      <!-- Contato, Data e Hora Contato Assistência -->
      <div class="vx-col xl:w-1/2 w-full lg:flex lg:gap-5 mb-2">
        <!-- Contato com Assistência -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Contato com Assistência</label>
          <vs-switch
            v-model="formDadosGerais.contatoAssistencia"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>

        <!-- Data Contato Assistência -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Contato Assistência</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDay"
              v-model="formDadosGerais.dataContatoAssistencia"
              placeholder="DD/MM/AAAA"
              name="Data de Contato da Assistência"
              :disabled="!formDadosGerais.contatoAssistencia"
            />
          </div>
        </div>

        <!-- Hora Contato Assistência -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Hora Contato Assistência</label>
          <div class="inputData">
            <vs-input
              class="w-full"
              v-model="formDadosGerais.horaContatoAssistencia"
              v-mask="'##:##'"
              maxlength="5"
              placeholder="HH:MM"
              name="Hora de Contato da Assistência"
              :disabled="!formDadosGerais.contatoAssistencia"
              @input="
                validaHoraMinuto(
                  formDadosGerais.horaContatoAssistencia,
                  'horaContatoAssistencia',
                )
              "
            />
          </div>
        </div>
      </div>

      <!-- Data e Hora Previsão Entrega -->
      <div class="vx-col xl:w-1/4 w-full lg:flex lg:gap-5 mb-2">
        <!-- Data Previsão Entrega -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Prev. Entrega</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePickerDay"
              v-model="formDadosGerais.dataPrevisaoEntrega"
              placeholder="DD/MM/AAAA"
              name="Data de Previsão de Entrega"
            />
          </div>
        </div>

        <!-- Hora Previsão Entrega -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Hora Prev. Entrega</label>
          <div class="inputData">
            <vs-input
              class="w-full"
              v-model="formDadosGerais.horaPrevisaoEntrega"
              v-mask="'##:##'"
              maxlength="5"
              placeholder="HH:MM"
              name="Hora de Previsão de Entrega"
              @input="
                validaHoraMinuto(
                  formDadosGerais.horaPrevisaoEntrega,
                  'horaPrevisaoEntrega',
                )
              "
            />
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Acionamento p/ terceiro -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Acionamento p/ terceiro</label>
        <vs-switch
          v-model="formDadosGerais.acionamentoParaTerceiro"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Veículo em locomoção -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Veículo em locomoção</label>
        <vs-switch
          v-model="formDadosGerais.veiculoEmLocomocao"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Sindicante no local -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Sindicante no local</label>
        <vs-switch
          v-model="formDadosGerais.sindicanteNoLocal"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Polícia Compareceu -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Polícia Compareceu</label>
        <vs-switch
          v-model="formDadosGerais.policiaCompareceu"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Veículo em Oficina -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Veículo em Oficina</label>
        <vs-switch
          v-model="formDadosGerais.veiculoEmOficina"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>

      <!-- Houve vítima? -->
      <div class="vx-col sm:w-1/2 xl:w-2/12 w-full mb-2">
        <label class="vs-input--label">Houve vítima?</label>
        <vs-switch
          v-model="formDadosGerais.possuiVitima"
          color="success"
          class="mt-2 ml-2"
        >
          <span slot="on">sim</span>
          <span slot="off">não</span>
        </vs-switch>
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Número Boletim de Ocorrência -->
      <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Número Boletim de Ocorrência"
          name="Número Boletim de Ocorrência"
          v-model="formDadosGerais.numeroBoletim"
        />
      </div>

      <!-- Data Registro BO -->
      <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
        <label class="vs-input--label">Data Registro BO</label>
        <div class="inputData">
          <flat-pickr
            :config="configdateTimePickerDay"
            v-model="formDadosGerais.dataBoletim"
            placeholder="DD/MM/AAAA"
            name="Data Registro BO"
          />
        </div>
      </div>

      <!-- Hora Registro BO -->
      <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
        <label class="vs-input--label">Hora Registro BO</label>
        <div class="inputData">
          <vs-input
            class="w-full"
            v-model="formDadosGerais.horaBoletim"
            v-mask="'##:##'"
            maxlength="5"
            placeholder="HH:MM"
            name="Hora Registro BO"
            @input="
              validaHoraMinuto(formDadosGerais.horaBoletim, 'horaBoletim')
            "
          />
        </div>
      </div>

      <!-- Órgão Responsável -->
      <div class="vx-col lg:w-1/2 xl:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Órgão Responsável"
          name="Órgão Responsável"
          v-model="formDadosGerais.orgaoRegistroBoletim"
        />
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Relato do Boletim de Ocorrência -->
      <div class="vx-col w-1/2">
        <vs-textarea
          label="Relato do Boletim de Ocorrência"
          v-model="formDadosGerais.descricaoBoletim"
        />
      </div>
    </div>

    <div class="vx-row mb-4">
      <!-- Faixa de trânsito do condutor do veículo beneficiário  -->
      <div class="vx-col lg:w-1/2">
        <label class="vs-input--label"
          >Faixa onde o condutor do veículo beneficiário transitava no momento
          do sinistro:</label
        >
        <div class="flex gap-5">
          <vs-radio
            v-model="formDadosGerais.faixaTransitoBeneficiario"
            vs-value="esquerda"
          >
            <label class="vs-input--label">Esquerda</label></vs-radio
          >
          <vs-radio
            v-model="formDadosGerais.faixaTransitoBeneficiario"
            vs-value="central"
          >
            <label class="vs-input--label">Central</label></vs-radio
          >
          <vs-radio
            v-model="formDadosGerais.faixaTransitoBeneficiario"
            vs-value="direita"
          >
            <label class="vs-input--label">Direita</label></vs-radio
          >
        </div>
      </div>

      <!-- Informação sobre a via -->
      <div class="vx-col lg:w-1/2">
        <label class="vs-input--label"
          >Informação sobre a via do sinistro:</label
        >
        <div class="flex gap-5">
          <vs-radio
            v-model="formDadosGerais.infoSobreViaEvento"
            vs-value="subida"
          >
            <label class="vs-input--label">Subida</label></vs-radio
          >
          <vs-radio
            v-model="formDadosGerais.infoSobreViaEvento"
            vs-value="descida"
          >
            <label class="vs-input--label">Descida</label></vs-radio
          >
          <vs-radio
            v-model="formDadosGerais.infoSobreViaEvento"
            vs-value="reta"
          >
            <label class="vs-input--label">Reta</label></vs-radio
          >
          <vs-radio
            v-model="formDadosGerais.infoSobreViaEvento"
            vs-value="curva"
          >
            <label class="vs-input--label">Curva</label></vs-radio
          >
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col lg:w-1/2 w-full mb-2">
        <!-- Rua da conversão realizada -->
        <vs-textarea
          class="w-full"
          label="Em caso de conversão, informar para qual rua/avenida:"
          name="Em caso de conversão, informar para qual rua/avenida:"
          v-model="formDadosGerais.ruaConversaoRealizada"
        />
      </div>

      <div class="vx-col lg:w-1/2 w-full mb-2">
        <!-- Motivo da perda do controle do veículo -->
        <vs-textarea
          class="w-full"
          label="Caso houver perda de controle de veículo, informar motivo:"
          name="Caso houver perda de controle de veículo, informar motivo:"
          v-model="formDadosGerais.motivoPerdaControleVeiculo"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col lg:w-1/2 w-full mb-2">
        <!-- Razão caso condutor tenha causado o acidente -->
        <vs-textarea
          class="w-full"
          label="Caso o condutor tenha causado o acidente, informar a razão:"
          name="Caso o condutor tenha causado o acidente, informar a razão::"
          v-model="formDadosGerais.razaoEnvolvidoCausouAcidente"
        />
      </div>

      <div class="vx-col lg:w-1/2 w-full mb-2">
        <!-- Sinalização do local do acidente -->
        <vs-textarea
          class="w-full"
          label="Caso houve sinalização no local, informar qual:"
          name="Caso houve sinalização no local, informar qual:"
          v-model="formDadosGerais.sinalizacaoLocalAcidente"
        />
      </div>
    </div>

    <div class="vx-row mt-4">
      <!-- Descrição detalhada do sinistro -->
      <div class="vx-col w-full">
        <vs-textarea
          label="Descrição detalhada do sinistro pelo beneficiário"
          v-model="formDadosGerais.descricaoDetalhada"
        />
      </div>
    </div>

    <div class="vx-row">
      <!-- Id Externo -->
      <div class="vx-col lg:w-1/2 w-full mb-2">
        <vs-input
          class="w-full"
          label="Id Externo"
          name="Id Externo"
          v-model="formDadosGerais.idExterno"
        />
      </div>

      <!-- Profissão do Beneficiário -->
      <div class="vx-col lg:w-1/2 w-full mb-2">
        <vs-input
          class="w-full"
          label="Profissão do Beneficiário"
          name="Profissão do Beneficiário"
          v-model="formDadosGerais.profissaoBeneficiario"
        />
      </div>
    </div>

    <!-- REMOVIDO TEMPORARIAMENTE -->
    <!-- Observaçõe -->
    <!-- <div class="vx-row">
      <div class="vx-col sm:w-1/1 w-full mb-2">
        <span class="vs-input--label">Observações</span>
        <vue-editor
          v-model="formDadosGerais.observacao"
          :editor-toolbar="customToolbar"
        ></vue-editor>
      </div>
    </div>

    <HistoricoObservacao :historicos="formDadosGerais.historicos" /> -->
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import vSelect from 'vue-select';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import customToolbar from './../../../../../../../components/editor/config';
import notify from '../../../../../../../utils/notify';

export default {
  props: ['formData', 'dominios'],
  watch: {
    formData(value) {
      if (!value.dadosGerais) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - DADOS GERAIS FORM');
        return;
      }

      this.formDadosGerais = Object.assign(
        this.formDadosGerais,
        value.dadosGerais,
      );

      // Remover os segundos de horaEvento
      if (this.formDadosGerais.horaEvento) {
        this.formDadosGerais.horaEvento = this.formDadosGerais.horaEvento
          .split(':')
          .filter((value, index) => index < 2)
          .join(':');
      }

      // Remover os segundos de horaBoletim
      if (this.formDadosGerais.horaBoletim) {
        this.formDadosGerais.horaBoletim = this.formDadosGerais.horaBoletim
          .split(':')
          .filter((value, index) => index < 2)
          .join(':');
      }

      // Remover os segundos de horaComunicacaoEvento
      if (this.formDadosGerais.horaComunicacaoEvento) {
        this.formDadosGerais.horaComunicacaoEvento =
          this.formDadosGerais.horaComunicacaoEvento
            .split(':')
            .filter((value, index) => index < 2)
            .join(':');
      }

      // Remover os segundos de horaContatoAssistencia
      if (this.formDadosGerais.horaContatoAssistencia) {
        this.formDadosGerais.horaContatoAssistencia =
          this.formDadosGerais.horaContatoAssistencia
            .split(':')
            .filter((value, index) => index < 2)
            .join(':');
      }

      // Remover os segundos de horaPrevisaoEntrega
      if (this.formDadosGerais.horaPrevisaoEntrega) {
        this.formDadosGerais.horaPrevisaoEntrega =
          this.formDadosGerais.horaPrevisaoEntrega
            .split(':')
            .filter((value, index) => index < 2)
            .join(':');
      }

      this.formData.dadosGerais = this.formDadosGerais;

      this.dataEventoOriginal = this.formDadosGerais.dataEvento;
    },
  },
  components: {
    vSelect,
    flatPickr,
  },
  data() {
    return {
      showComponent: true,
      formDadosGerais: {
        idTipoEvento: null,
        descricaoTipoEvento: null,
        idStatus: null,
        idEnvolvimento: null,
        descricaoEnvolvimento: null,
        dataEvento: null,
        horaEvento: null,
        dataHoraEvento: null,
        dataComunicacaoEvento: null,
        horaComunicacaoEvento: null,
        dataHoraComunicacaoEvento: null,
        dataContatoAssistencia: null,
        horaContatoAssistencia: null,
        dataHoraContatoAssistencia: null,
        dataPrevisaoEntrega: null,
        horaPrevisaoEntrega: null,
        dataHoraPrevisaoEntrega: null,
        contatoAssistencia: null,
        acionamentoParaTerceiro: null,
        veiculoEmLocomocao: null,
        sindicanteNoLocal: null,
        policiaCompareceu: null,
        veiculoEmOficina: null,
        possuiVitima: null,
        numeroBoletim: null,
        dataBoletim: null,
        horaBoletim: null,
        dataHoraBoletim: null,
        orgaoRegistroBoletim: null,
        descricaoBoletim: null,
        idExterno: null,
        idUsuario: null,
        observacao: null,
        historicos: [],
        faixaTransitoBeneficiario: null,
        infoSobreViaEvento: null,
        ruaConversaoRealizada: null,
        motivoPerdaControleVeiculo: null,
        descricaoDetalhada: null,
        razaoEnvolvidoCausouAcidente: null,
        sinalizacaoLocalAcidente: null,
        profissaoBeneficiario: null,
        alterouAnoMesDataEvento: false,
      },
      listMotivos: [],
      listEnvolvimentos: [],

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      customToolbar,
      dataEventoOriginal: null,
    };
  },
  methods: {
    selectMotivoEvento(value) {
      this.formDadosGerais.descricaoTipoEvento = value.label;
    },
    selectEnvolvimento(value) {
      this.formDadosGerais.descricaoEnvolvimento = value.label;
    },
    validaHoraMinuto(newValue, campo) {
      if (newValue.length >= 5) {
        if (!/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(newValue)) {
          notify.notifyFail(
            this.$vs,
            `Hora ${campo} inválida. Insira uma hora válida no formato HH:MM`,
          );
          this.formDadosGerais[campo] = '';
        }
      }
    },
    validaAlteracaoDataEvento(novaDataEvento) {
      const arrayDataOriginal = this.dataEventoOriginal.split('/');
      const arrayDataNova = novaDataEvento.split('/');
      const anosDiferentes = arrayDataOriginal[2] !== arrayDataNova[2];
      const mesesDiferentes = arrayDataOriginal[1] !== arrayDataNova[1];

      if (anosDiferentes || mesesDiferentes) {
        this.formDadosGerais.alterouAnoMesDataEvento = true;
        return;
      }

      this.formDadosGerais.alterouAnoMesDataEvento = false;
    },
  },
  mounted() {
    if (!this.formData.dadosGerais) {
      console.error('ERRO NO CONTRATO DO OBJETO - DADOS GERAIS FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.dadosGerais = this.formDadosGerais;

    if (this.dominios) {
      this.listMotivos = this.dominios.listMotivos;
      this.listEnvolvimentos = this.dominios.listEnvolvimentos;
    }
  },
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}
input.flatpickr-input {
  width: 100%;
}

.vx-row.divider {
  border: 0.5px solid rgba(0, 0, 0, 0.08);
}
</style>

<style src="./../../../../../../../components/editor/style-editor.css"></style>
